module.exports = __webpack_public_path__ + "static/media/saltswap.622dd9ff.png";